// actions
import {
  GET_AUDIT,
  GET_LIKES,
  GET_AUDIENCE,
  SET_LIKES,
  SET_AUDIENCE,
  GET_AGE,
  GET_THEMATIC,
  SET_THEMATIC,
  SET_AGE,
  CHANGE_AGE,
  GET_IN_AGE,
  SET_IN_AGE,
  GET_SUMMARY,
  SET_SUMMARY,
  GET_SEX,
  SET_SEX,
  SET_AUDIT_PERIOD,
  SET_AUDIT_PERIOD_NAME,
  SET_AUDIT_PENDING,
  SET_AUDIT_GLOBAL_PERIOD,
  UPDATE_AUDIT_CHART
} from "../../store/actions/audit";

// libraries
import moment from "moment";
import {cloneDeep} from "lodash/lang";

// const
const DATE_FORMAT = "YYYY-MM-DD HH:mm:ss";

// api
import { getStatsApi, getStatsAgeApi, getStatsAgesApi, getThematicRatioApi } from "../../api/stats";
import { getThreadAtTendanceApi } from "../../api/feeds";

// functions
import {setAge} from '../../helpers/ageMethods';

const getStartDate = () => {
  const start = new Date();
  start.setDate(start.getDate() - 6);
  start.setHours(0);
  start.setMinutes(0);
  start.setSeconds(0);

  const end = new Date();
  end.setHours(23);
  end.setMinutes(59);
  end.setSeconds(59);

  return [moment(start).format(DATE_FORMAT), moment(end).format(DATE_FORMAT)];
};

const getStatParams = (thread, chart, state) => {
  return {
    thread_id: parseInt(thread),
    from: state.auditCharts[chart].period[0],
    to: state.auditCharts[chart].period[1],
    type: state.auditCharts[chart].type
  };
};

const getAudienceParams = (thread, chart, state) => {
  return {
    thread_id: parseInt(thread),
    from: state.auditCharts[chart].period[0],
    to: state.auditCharts[chart].period[1],
    need_graph: true
  };
};

const getStatAgesParams = (thread, chart, state) => {
  return {
    thread_id: parseInt(thread),
    from: state.auditCharts[chart].period[0],
    to: state.auditCharts[chart].period[1],
    group1_start: setAge(state.ages.group1, 0),
    group1_end: setAge(state.ages.group1, 1),
    group2_start: setAge(state.ages.group2, 0),
    group2_end: setAge(state.ages.group2, 1),
    group3_start: setAge(state.ages.group3, 0),
    group3_end: setAge(state.ages.group3, 1),
    group4_start: setAge(state.ages.group4, 0),
    group4_end: setAge(state.ages.group4, 1),
  };
};

const getStatData = (params, commit, chart, action) => {
  getStatsApi(params)
    .then(resp => {
      commit(SET_AUDIT_PENDING, {chart, pending: false});
      commit(action, {chart, data: resp.data});
    })
    .catch(() => {
      commit(SET_AUDIT_PENDING, {chart, pending: false});
    });
};

const getAudienceData = (params, commit, chart, action) => {
  getThreadAtTendanceApi(params)
    .then(resp => {
      commit(SET_AUDIT_PENDING, {chart, pending: false});
      commit(action, {chart, data: resp.data});
    })
    .catch(() => {
      commit(SET_AUDIT_PENDING, {chart, pending: false});
    });
};

const getStatAgesData = (params, commit, chart, action) => {
  getStatsAgesApi(params)
    .then(resp => {
      commit(SET_AUDIT_PENDING, {chart, pending: false});
      commit(action, {chart, data: resp.data});
    })
    .catch(() => {
      commit(SET_AUDIT_PENDING, {chart, pending: false});
    });
};

const getThematicRatioData = (params, commit, chart, action) => {
  getThematicRatioApi(params)
    .then(resp => {
      commit(SET_AUDIT_PENDING, {chart, pending: false});
      commit(action, {chart, data: resp.data});
    })
    .catch(() => {
      commit(SET_AUDIT_PENDING, {chart, pending: false});
    });
};

const getStatAgeData = (params, commit, chart, action) => {
  getStatsAgeApi(params)
    .then(resp => {
      commit(SET_AUDIT_PENDING, {chart, pending: false});
      commit(action, {chart, data: resp.data});
    })
    .catch(() => {
      commit(SET_AUDIT_PENDING, {chart, pending: false});
    });
};

// store
const state = {
  globalPeriod: getStartDate(),
  ages: {
    group1: '14-25',
    group2: '26-39',
    group3: '40-54',
    group4: '55+',
  },
  auditCharts: {
    Views: {
      data: {},
      editFunction: (state, data, chart, index, value) => {
        data.graph_data[index][1] = value;
        state.auditCharts[chart].data = cloneDeep(data);
      },
      type: "views",
      periodName: null,
      action: GET_LIKES,
      period: getStartDate(),
      request: {
        pending: false,
        error: false
      }
    },
    Involvement: {
      data: {},
      editFunction: (state, data, chart, index, value, key) => {
        data.graph_data[key][index][1] = value;
        state.auditCharts[chart].data = cloneDeep(data);
      },
      type: "age",
      periodName: null,
      action: GET_AGE,
      period: getStartDate(),
      request: {
        pending: false,
        error: false
      }
    },
    Sex: {
      data: {},
      editFunction: (state, data, chart, index, value) => {
        data.additional_data.sex[index]= value;
        state.auditCharts[chart].data = cloneDeep(data);
      },
      type: "sex",
      periodName: null,
      action: GET_SEX,
      period: getStartDate(),
      request: {
        pending: false,
        error: false
      }
    },
    Age: {
      data: {},
      editFunction: (state, data, chart, index, value) => {
        data.additional_data.age[index]= value;
        state.auditCharts[chart].data = cloneDeep(data);
      },
      type: "age",
      periodName: null,
      action: GET_IN_AGE,
      period: getStartDate(),
      request: {
        pending: false,
        error: false
      }
    },
    Thematics: {
      data: {},
      editFunction: (state, data, chart, index, value) => {

        data[0][ratio] = value;
        state.auditCharts[chart].data = cloneDeep(data);
      },
      type: "thematics",
      periodName: null,
      action: GET_THEMATIC,
      period: getStartDate(),
      request: {
        pending: false,
        error: false
      }
    },
    SummaryLikesAndReposts: {
      data: [],
      editFunction: (state, data, chart, index, value, key) => {

        let arrayKey = 0;
        data.forEach((item, dataKey) => {
          if(item[key]) {
            arrayKey = dataKey;
          }
        });

        data[arrayKey][key].graph_data[index][1] = value;
        state.auditCharts[chart].data = cloneDeep(data);
      },
      type: ["likes", "reposts", "comments"],
      periodName: null,
      action: GET_SUMMARY,
      period: getStartDate(),
      request: {
        pending: false,
        error: false
      }
    },
    ReachAudience: {
      data: {},
      editFunction: (state, data, chart, index, value) => {
        data.graph[index][1] = value;
        state.auditCharts[chart].data = cloneDeep(data);
      },
      type: ["audience"],
      periodName: null,
      action: GET_AUDIENCE,
      period: getStartDate(),
      request: {
        pending: false,
        error: false
      }
    }
  }
};

const getters = {
  auditData: state => chart => {
    return state.auditCharts[chart].data;
  },
  ages: state => {
    return state.ages;
  },
  auditPending: state => chart => {
    return state.auditCharts[chart].request.pending;
  },
  auditPeriodName: state => (chart, i18n) => {
    let periodName = state.auditCharts[chart].periodName;
    if(!periodName) {
      return i18n.t('feed.audit.views.periodName');
    }
    return periodName;
  },
  getAuditPeriod: state => chart => {
    return state.auditCharts[chart].period;
  },
  isAuditLoaded: state => chart => {
    return Object.keys(state.auditCharts[chart].data).length > 0;
  },
  getGlobalAuditPeriod: state => state.globalPeriod
};

const actions = {
  [CHANGE_AGE]: ({ commit }, {val, idx}) => {
    commit(CHANGE_AGE, {val, idx});
  },
  [GET_AUDIT]: ({ state, commit, dispatch }, payload) => {
    const { chart } = payload;
    commit(SET_AUDIT_PENDING, {chart, pending: true});
    dispatch(state.auditCharts[chart].action, payload);
  },
  [SET_AUDIT_PERIOD_NAME]: ({ state, commit, dispatch }, payload) => {
    commit(SET_AUDIT_PERIOD_NAME, payload);
  },
  [SET_AUDIT_PERIOD]: ({ state, commit, dispatch }, payload) => {
    commit(SET_AUDIT_PERIOD, payload);
  },
  [SET_AUDIT_GLOBAL_PERIOD]: ({ state, commit, dispatch }, payload) => {
    commit(SET_AUDIT_GLOBAL_PERIOD, payload);
    const stateEntries = Object.entries(state.auditCharts);

    stateEntries.forEach(item => {
      commit(SET_AUDIT_PERIOD, {chart: item[0], period: payload.period});
      commit(SET_AUDIT_PERIOD_NAME, {chart: item[0], title: payload.title});
      commit(SET_AUDIT_PENDING, {chart: item[0], pending: true});
      dispatch(item[1].action, {chart: item[0], thread: payload.thread});
    });

  },
  [GET_AGE]: ({ state, commit, dispatch }, payload) => {
    const { chart, thread } = payload;

    /*const params = getStatParams(thread, chart, state);
    getStatData(params, commit, chart, SET_AGE);*/
    const params = getStatAgesParams(thread, chart, state);
    getStatAgesData(params, commit, chart, SET_AGE);
  },
  [GET_IN_AGE]: ({ state, commit, dispatch }, payload) => {
    const { chart, thread } = payload;

    /*const params = getStatParams(thread, chart, state);
    getStatAgeData(params, commit, chart, SET_IN_AGE);*/
    const params = getStatAgesParams(thread, chart, state);
    getStatAgesData(params, commit, chart, SET_AGE);
  },
  [GET_THEMATIC]: ({ state, commit, dispatch }, payload) => {
    const { chart, thread } = payload;

    /*const params = getStatParams(thread, chart, state);
    getStatData(params, commit, chart, SET_AGE);*/
    const params = getStatParams(thread, chart, state);
    getThematicRatioData(params, commit, chart, SET_THEMATIC);
  },
  [GET_LIKES]: ({ state, commit, dispatch }, payload) => {
    const { chart, thread } = payload;

    const params = getStatParams(thread, chart, state);

    getStatData(params, commit, chart, SET_LIKES);
  },
  [GET_AUDIENCE]: ({ state, commit, dispatch }, payload) => {
    const { chart, thread } = payload;

    const params = getAudienceParams(thread, chart, state);

    getAudienceData(params, commit, chart, SET_AUDIENCE);
  },
  [GET_SEX]: ({ state, commit, dispatch }, payload) => {
    const { chart, thread } = payload;

    const params = getStatParams(thread, chart, state);
    getStatAgeData(params, commit, chart, SET_SEX);
  },
  [GET_SUMMARY]: ({ state, commit, dispatch }, payload) => {
    const { chart, thread } = payload;

    Promise.all(state.auditCharts[chart].type.map(async item =>
      getStatsApi(
        {
          thread_id: parseInt(thread),
          from: state.auditCharts[chart].period[0],
          to: state.auditCharts[chart].period[1],
          type: item
        })
        .then(statResp => {
          return {[item]: statResp.data};
        })
    )).then(data => {
      commit(SET_AUDIT_PENDING, {chart, pending: false});
      commit(SET_SUMMARY, {chart, data});
    });

  },

  [UPDATE_AUDIT_CHART]: ({ commit }, payload) => {
    commit(UPDATE_AUDIT_CHART, payload);
    return Promise.resolve();
  },
};

const mutations = {
  [CHANGE_AGE]: (state, {val, idx}) => {
    state.ages[idx] = val;
  },
  [SET_AUDIT_PERIOD]: (state, payload) => {
    const {chart, period} = payload;
    state.auditCharts[chart].period = period;
  },
  [SET_AUDIT_GLOBAL_PERIOD]: (state, payload) => {
    const {period} = payload;
    state.globalPeriod = period;
  },
  [SET_AUDIT_PERIOD_NAME]: (state, payload) => {
    const {chart, title} = payload;
    state.auditCharts[chart].periodName = title;
  },
  [SET_LIKES]: (state, payload) => {
    const {chart, data} = payload;
    state.auditCharts[chart].data = data;
  },
  [SET_AUDIENCE]: (state, payload) => {
    const {chart, data} = payload;
    state.auditCharts[chart].data = data;
  },
  [SET_AGE]: (state, payload) => {
    const {chart, data} = payload;
    state.auditCharts[chart].data = data;
  },
  [SET_IN_AGE]: (state, payload) => {
    const {chart, data} = payload;
    state.auditCharts[chart].data = data;
  },
  [SET_THEMATIC]: (state, payload) => {
    const {chart, data} = payload;
    state.auditCharts[chart].data = data;
  },
  [SET_SEX]: (state, payload) => {
    const {chart, data} = payload;
    state.auditCharts[chart].data = data;
  },
  [SET_SUMMARY]: (state, payload) => {
    const {chart, data} = payload;
    state.auditCharts[chart].data = data;
  },
  [SET_AUDIT_PENDING]: (state, {chart, pending}) => {
    state.auditCharts[chart].request.pending = pending;
  },
  [UPDATE_AUDIT_CHART]: (state, { chart, value, index, key }) => {
    let data = cloneDeep(state.auditCharts[chart].data);
    state.auditCharts[chart].editFunction(state, data, chart, index, value, key);
    data = null;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
